import React from "react";

import { Box, Divider, Typography, Stack } from '@mui/material';

import HtmlHeader from "./HtmlHeader";
import theme_ from "theme/CurrentTheme";


interface Props {
    htmlTitle?: string;
    current?: string;

    title?: string;
    description?: string;
}

//justifyContent='center'

export default function PageHeader(props: Props) {
    return <Box display='flex' flexDirection='column'  alignItems='center' sx={{
        borderBottom: 1,
        height: theme_.pageHeaderHeight,
    }}>
        <HtmlHeader title={props.htmlTitle ?? "Mirzoyan"}/>

        {/* <Stack direction='column' sx={{width: 1}}> */}

        <Box display='block' sx={{
            maxWidth: theme_.pageContentsWidth,
        }}>
            {props.title && <Typography>{props.title}</Typography>}
            {props.description && <Typography>{props.description}</Typography>}
        </Box>

        {/* <p>header</p> */}

        {/* <Divider sx={{width: 1}}/> */}
        {/* </Stack> */}

    </Box>
}

